var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "top-menu", class: _vm.classObj, attrs: { id: "topMenu" } },
    [
      _c(
        "el-menu",
        {
          attrs: {
            mode: "horizontal",
            "unique-opened": true,
            "default-active": _vm.activeName,
          },
        },
        _vm._l(_vm.list, function (route) {
          return _c("sidebar-item", {
            key: route.enCode,
            ref: "sidebarItem",
            refInFor: true,
            attrs: { item: route, "base-path": route.path },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }